module.exports = __webpack_public_path__ + "static/media/NameButtonIcon.bcfef7a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/NameButtonIcon.svg
// module id = 317
// module chunks = 0